import { z } from 'zod';

export const NullDataSchema = z.null();
